function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clothes-8_svg__id-4a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 218c0-33.137 27.187-60 60.723-60h46.554C172.813 158 200 184.863 200 218v14H32v-14z",
  fill: "#2F80ED"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 116,
  cy: 160,
  rx: 28,
  ry: 12,
  fill: "#72AEFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164 163c20.495 2.277 36 19.601 36 40.222V239h-36v-76zm-96 0c-20.495 2.277-36 19.601-36 40.222V239h36v-76z",
  fill: "#72AEFF"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clothes-8_svg__id-4a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h232v232H0z"
})));

function SvgClothes8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/clothes-8.9c4a6731.svg";
export { SvgClothes8 as ReactComponent };